// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OsGu","label":"styles_label__E_tKg"};